import Overview from './Overview'

export const mediaRoutes = [
    {
      path: '/media',
      name: 'Media',
      component: Overview,
      meta: { requiresAuth: true, minRole: 1}
    }]


// WEBPACK FOOTER //
// ./src/CORE/modules/MEDIA/routes.js